/*
  RevoRope — modal genérico (diálogo a pantalla partida).

  MISMO patrón de accesibilidad que el overlay del menú móvil de rr-nav.js, extraído
  aquí para que exista UNA sola definición reutilizable en vez de dos implementaciones
  parecidas: foco atrapado dentro del panel mientras está abierto, Escape cierra,
  clic en el fondo cierra, botón de cerrar cierra, el foco vuelve al disparador,
  aria-expanded del disparador refleja el estado y el scroll de fondo se bloquea.

  Marcado esperado:
    <button data-rr-modal-open="ID" aria-haspopup="dialog" aria-expanded="false">…</button>
    <div class="rr-modal" id="ID" data-rr-modal hidden>
      <div class="rr-modal__panel" role="dialog" aria-modal="true" data-rr-modal-panel>
        <button data-rr-modal-close>…</button>
        …
      </div>
    </div>

  El overlay debe vivir FUERA de cualquier .rr-reveal (mientras no está revelado
  lleva transform, y un transform en un antecesor rompe position:fixed).
*/
(function () {
  'use strict';

  var overlays = Array.prototype.slice.call(document.querySelectorAll('[data-rr-modal]'));
  if (!overlays.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CERRAR_MS = 240;
  var FOCO = 'a[href], button:not([disabled]), summary, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  overlays.forEach(function (overlay) {
    var panel = overlay.querySelector('[data-rr-modal-panel]');
    if (!panel) return;

    var id = overlay.id;
    var disparadores = id
      ? Array.prototype.slice.call(document.querySelectorAll('[data-rr-modal-open="' + id + '"]'))
      : [];
    if (!disparadores.length) return;

    var cierres = Array.prototype.slice.call(overlay.querySelectorAll('[data-rr-modal-close]'));
    var abierto = false;
    var hideTimer = null;
    var devolverFoco = null;

    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll(FOCO)).filter(function (el) {
        return el.getClientRects().length > 0;
      });
    }

    function onKeydown(evento) {
      if (evento.key === 'Escape') {
        evento.preventDefault();
        cerrar();
        return;
      }
      if (evento.key !== 'Tab') return;
      var lista = focusables();
      if (!lista.length) return;
      // El tabulador NUNCA se deja al navegador: calculamos nosotros el siguiente.
      // Dejar pasar el Tab "cuando el foco no está ni al principio ni al final" es
      // la versión ingenua del patrón y tiene una fuga real, medida en vivo: si en
      // la página hay algo enfocable inyectado por fuera del tema (el banner de
      // cookies de Shopify, por ejemplo), el navegador puede saltar ahí aunque el
      // modal esté abierto. Moviendo el foco por índice, no hay salida posible.
      evento.preventDefault();
      var actual = lista.indexOf(document.activeElement);
      var siguiente;
      if (actual === -1) {
        siguiente = evento.shiftKey ? lista.length - 1 : 0;
      } else {
        siguiente = evento.shiftKey ? actual - 1 : actual + 1;
        if (siguiente < 0) siguiente = lista.length - 1;
        if (siguiente >= lista.length) siguiente = 0;
      }
      lista[siguiente].focus();
    }

    function abrir(evento) {
      if (abierto) return;
      abierto = true;
      devolverFoco = (evento && evento.currentTarget) || disparadores[0];
      window.clearTimeout(hideTimer);
      overlay.hidden = false;
      // Reflow para que la transición de entrada se dispare.
      void overlay.offsetWidth;
      overlay.classList.add('is-open');
      document.documentElement.classList.add('rr-noscroll');
      disparadores.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      document.addEventListener('keydown', onKeydown, true);
      var primero = cierres[0] || focusables()[0];
      if (primero) primero.focus();
    }

    function cerrar() {
      if (!abierto) return;
      abierto = false;
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('rr-noscroll');
      disparadores.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.removeEventListener('keydown', onKeydown, true);
      var ms = reduce.matches ? 0 : CERRAR_MS;
      hideTimer = window.setTimeout(function () {
        overlay.hidden = true;
      }, ms);
      if (devolverFoco) devolverFoco.focus();
    }

    disparadores.forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', abrir);
    });
    cierres.forEach(function (b) { b.addEventListener('click', cerrar); });

    // Clic en el fondo (fuera del panel) cierra.
    overlay.addEventListener('click', function (evento) {
      if (evento.target === overlay) cerrar();
    });

    // Un enlace real dentro del panel navega: dejamos el modal cerrado.
    panel.addEventListener('click', function (evento) {
      var enlace = evento.target.closest ? evento.target.closest('a[href]') : null;
      if (enlace && panel.contains(enlace)) cerrar();
    });
  });
})();
